/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  position: relative;
  width: inherit;
  height: inherit;
`

export default function LogoShieldIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="74.628" viewBox="0 0 90 74.628" css={Color}>
      <path id="패스_5339" data-name="패스 5339" d="M879.89,284.63c-12.789-7.286-31.414-12.394-39.681-14.44a19.6,19.6,0,0,0-8.926-.015c-8.267,2.046-26.413,7.169-39.2,14.455a2.17,2.17,0,0,0-1.089,2.047c.516,6.934,5.056,38.518,44.994,57.619,39.938-19.1,44.478-50.684,44.994-57.619A2.17,2.17,0,0,0,879.89,284.63Zm-23.531,14.651h-7.121v-2.471l-.052-.03-13.571-7.839-.052-.03-.052.03-13.584,7.839-.052.03v5.181h34.483v14.735l-16.1,9.29-.052.03v5.345l-4.581-2.63-.024-.014h-.013l-20.81-12.021v-6.59H835.46v4.849h-9.488l.335.193,9.2,5.311.052.03.052-.03,13.571-7.839.052-.03v-5.193H814.781V292.7l16.187-9.341.052-.03V278.1l4.492,2.579.069.039.013-.013L856.359,292.7Z" transform="translate(-790.985 -269.667)"/>
    </svg>
  )
}
